import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {useContext} from "react";
import {AuthContext, AUTHSTATES} from "./AuthProvider";
import {Box, CircularProgress} from "@mui/joy";
import { Page404 } from "../pages/Page404";
import { Login } from "../pages/Login";
import { Home } from "../pages/Home";
import {Categorie} from "../pages/Categorie";
import {Servizi} from "../pages/Servizi";
import {Mappa} from "../pages/Mappa";
import {Utenti} from "../pages/Utenti";
import {Traduzioni} from "../pages/Traduzioni";
import {Impostazioni} from "../pages/Impostazioni";
import {SUPER_ADMIN_EMAIL} from "./Utils";

export function Router() {

    const {authState, currentUser} = useContext(AuthContext)
    const isSuperAdmin = currentUser?.email === SUPER_ADMIN_EMAIL
    return (
        <>
            {
                authState === AUTHSTATES.UNKNOWN ?
                    <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", width:"100vw", height:"100vh"}}>
                        <CircularProgress />
                    </Box>
                    :
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={authState === AUTHSTATES.LOGGEDIN ? <Navigate to="/" /> : <Login />} />
                            <Route path="/" element={authState === AUTHSTATES.LOGGEDIN ? <Home /> : <Navigate to="/login" />} />
                            <Route path="/categorie" element={authState === AUTHSTATES.LOGGEDIN ? <Categorie /> : <Navigate to="/login" />} />
                            <Route path="/servizi" element={authState === AUTHSTATES.LOGGEDIN ? <Servizi /> : <Navigate to="/login" />} />
                            <Route path="/mappa" element={authState === AUTHSTATES.LOGGEDIN ? <Mappa /> : <Navigate to="/login" />} />
                            <Route path="/utenti" element={authState === AUTHSTATES.LOGGEDIN ? <Utenti /> : <Navigate to="/login" />} />
                            <Route path="/traduzioni" element={authState === AUTHSTATES.LOGGEDIN ? <Traduzioni /> : <Navigate to="/login" />} />
                            <Route path="/impostazioni" element={
                                authState !== AUTHSTATES.LOGGEDIN ? <Navigate to="/login" /> :
                                    isSuperAdmin ? <Impostazioni /> : <Navigate to="/" />
                            } />
                            <Route path="*" element={<Page404 />} />
                        </Routes>
                    </BrowserRouter>
            }
        </>
    )
}